<template>
  <div>
    <!-- Search Box -->
    <input
      type="text"
      v-model="searchLocation"
      placeholder="Enter location"
      @keyup.enter="searchPlace"
    />
    <button @click="searchPlace">Search</button>

    <div ref="mapContainer" class="map-container"></div>

    <!-- Location List -->
    <div
      v-for="(location, i) in SelectedLoctions"
      :key="location"
      class="marker-item"
    >
      <div>🌍 Country: {{ location.country || "Fetching..." }}</div>

      <div
        v-for="(marker, index) in SelectedLoctions[i]"
        :key="index"
        class="d-flex align-center justify-space-between"
      >
        <span class="d-flex align-center ga-2 text-caption">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="#39CA8E"
            xmlns="http://www.w3.org/2000/svg"
            class="sds-icon sds-icon-check styles-im1iax"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6 10.9394L12.803 4.13635L13.8637 5.19701L6 13.0607L2.13634 9.19701L3.197 8.13635L6 10.9394Z"
            ></path>
          </svg>
          {{ marker.lng }}
          {{ marker.lat }}
          <input
            type="number"
            v-model="marker.radius"
            min="1"
            max="50"
            @input="updateCircle(index)"
          />
          miPoint Radius
        </span>
        <svg
          @click="removeMarker(index)"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="#444546"
          xmlns="http://www.w3.org/2000/svg"
          class="sds-icon sds-icon-cross cursor-pointer"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8 9.8535L11.6239 13.4774L12.8614 12.24L9.23744 8.61606L12.8614 4.99214L11.6239 3.7547L8 7.37862L4.37609 3.75471L3.13865 4.99215L6.76256 8.61606L3.13864 12.24L4.37608 13.4774L8 9.8535Z"
          ></path>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import mapboxgl from "mapbox-gl";
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";

export default {
  data() {
    return {
      map: null,
      markers: [], // Stores all markers, radius, and country info
      searchLocation: "",
    };
  },
  mounted() {
    mapboxgl.accessToken =
      "tk.eyJ1IjoibmttYXAiLCJleHAiOjE3NDI5MDg4MDYsImlhdCI6MTc0MjkwNTIwNiwic2NvcGVzIjpbInN0eWxlczp0aWxlcyIsInN0eWxlczpyZWFkIiwiZm9udHM6cmVhZCIsImRhdGFzZXRzOnJlYWQiXSwiY2xpZW50IjoiYXBpIn0.3GD4E0bViAXcriTAAgMVXw";

    this.map = new mapboxgl.Map({
      container: this.$refs.mapContainer,
      style: "mapbox://styles/mapbox/streets-v11",
      center: [-74.5, 40], // Default location
      zoom: 10,
    });

    const geocoder = new MapboxGeocoder({
      accessToken: mapboxgl.accessToken,
      mapboxgl: mapboxgl,
      marker: false,
    });

    this.map.addControl(geocoder);

    geocoder.on("result", async (e) => {
      await this.addMarker(e.result.center[0], e.result.center[1]);
    });

    this.map.on("click", async (e) => {
      await this.addMarker(e.lngLat.lng, e.lngLat.lat);
    });
  },
  methods: {
    async searchPlace() {
      if (!this.searchLocation) return;

      const response = await fetch(
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${this.searchLocation}.json?access_token=tk.eyJ1IjoibmttYXAiLCJleHAiOjE3NDI5MDg4MDYsImlhdCI6MTc0MjkwNTIwNiwic2NvcGVzIjpbInN0eWxlczp0aWxlcyIsInN0eWxlczpyZWFkIiwiZm9udHM6cmVhZCIsImRhdGFzZXRzOnJlYWQiXSwiY2xpZW50IjoiYXBpIn0.3GD4E0bViAXcriTAAgMVXw`
      );
      const data = await response.json();
      if (data.features.length === 0) return;

      await this.addMarker(
        data.features[0].center[0],
        data.features[0].center[1]
      );
    },
    async addMarker(lng, lat) {
      const marker = new mapboxgl.Marker({ draggable: true })
        .setLngLat([lng, lat])
        .addTo(this.map);

      marker.on("dragend", async () => {
        const lngLat = marker.getLngLat();
        this.updateMarkerPosition(marker, lngLat.lng, lngLat.lat);
      });

      const country = await this.getCountry(lng, lat);

      this.markers.push({ marker, lng, lat, radius: 10, country });
      this.updateCircle(this.markers.length - 1);
    },
    async getCountry(lng, lat) {
      try {
        const response = await fetch(
          `https://api.mapbox.com/geocoding/v5/mapbox.places/${lng},${lat}.json?types=country&access_token=tk.eyJ1IjoibmttYXAiLCJleHAiOjE3NDI5MDg4MDYsImlhdCI6MTc0MjkwNTIwNiwic2NvcGVzIjpbInN0eWxlczp0aWxlcyIsInN0eWxlczpyZWFkIiwiZm9udHM6cmVhZCIsImRhdGFzZXRzOnJlYWQiXSwiY2xpZW50IjoiYXBpIn0.3GD4E0bViAXcriTAAgMVXw`
        );
        const data = await response.json();
        return data.features.length > 0
          ? data.features[0].place_name === "Israel"
            ? "Palestine"
            : data.features[0].text
          : "Unknown";
      } catch (error) {
        console.error("Error fetching country:", error);
        return "Unknown";
      }
    },
    updateMarkerPosition(marker, lng, lat) {
      const index = this.markers.findIndex((m) => m.marker === marker);
      if (index !== -1) {
        this.markers[index].lng = lng;
        this.markers[index].lat = lat;
        this.updateCircle(index);
      }
    },
    removeMarker(index) {
      this.markers[index].marker.remove();

      const sourceId = `circle-source-${index}`;
      const layerId = `circle-layer-${index}`;

      if (this.map.getLayer(layerId)) {
        this.map.removeLayer(layerId);
      }
      if (this.map.getSource(sourceId)) {
        this.map.removeSource(sourceId);
      }

      this.markers.splice(index, 1);
      this.redrawCircles();
    },
    updateCircle(index) {
      const marker = this.markers[index];
      if (!marker) return;

      const sourceId = `circle-source-${index}`;
      const layerId = `circle-layer-${index}`;

      if (this.map.getLayer(layerId)) {
        this.map.removeLayer(layerId);
      }
      if (this.map.getSource(sourceId)) {
        this.map.removeSource(sourceId);
      }

      const circleGeoJSON = this.createCircle(
        marker.lng,
        marker.lat,
        marker.radius * 1000
      );

      this.map.addSource(sourceId, {
        type: "geojson",
        data: circleGeoJSON,
      });

      this.map.addLayer({
        id: layerId,
        type: "fill",
        source: sourceId,
        paint: {
          "fill-color": "#007AFF",
          "fill-opacity": 0.3,
        },
      });
    },
    redrawCircles() {
      this.markers.forEach((_, index) => this.updateCircle(index));
    },
    createCircle(lng, lat, radius) {
      const points = 64;
      const coords = [];
      for (let i = 0; i < points; i++) {
        const angle = (i * 360) / points;
        const offsetX = radius * Math.cos((angle * Math.PI) / 180);
        const offsetY = radius * Math.sin((angle * Math.PI) / 180);
        const newLng = lng + offsetX / 111320;
        const newLat = lat + offsetY / 110540;
        coords.push([newLng, newLat]);
      }
      coords.push(coords[0]);
      return {
        type: "Feature",
        geometry: {
          type: "Polygon",
          coordinates: [coords],
        },
      };
    },
  },
  watch: {
    SelectedLoctions() {
      console.log(this.SelectedLoctions);
    },
  },
  computed: {
    SelectedLoctions() {
      return this.markers.reduce((acc, marker) => {
        if (!acc[marker.country]) {
          acc[marker.country] = [];
        }
        acc[marker.country].push(marker);
        return acc;
      }, {});
    },
  },
};
</script>

<style scoped>
.map-container {
  margin-bottom: 20px;
}
.marker-item {
  background: #f5f5f5;
  padding: 10px;
  margin: 10px 0;
  border-radius: 5px;
}
.marker-item input {
  margin: 5px;
  padding: 5px;
  width: 60px;
}
</style>
